export const detectLanguage = (): string => {
  const found = [];
  const { languages, language } = navigator;

  if (languages) {
    // chrome only; not an array, so can't use .push.apply instead of iterating
    for (let i = 0; i < languages.length; i++) {
      found.push(languages[i]);
    }
  }

  if (language) {
    found.push(language);
  }

  if (found.length > 0) {
    const lang = found[0] as string;
    const langArray = lang.replace("-", "_").split("_");

    if (langArray[0] === "zh") {
      return convertChineseLang(lang);
    }

    return langArray[0].toUpperCase();
  }

  return "EN";
};

const convertChineseLang = (code: string) => {
  switch (code) {
    case "zh_TW":
    case "zh-TW":
      return "TW";
    default:
      return "ZH";
  }
};

export default {
  name: "rlinkDetector",

  lookup() {
    return detectLanguage();
  },
};
